/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useMemo, useRef } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import { SlideIn, ExitingPersistence, mediumDurationMs } from '@atlaskit/motion';
// eslint-disable-next-line @atlaskit/design-system/no-banned-imports

import { formatLargeNumber } from '../../shared/utils';
import { containerStyle, counterLabelStyle, countStyle, highlightStyle } from './styles';

/**
 * Test id for component top level div
 */
export var RENDER_COMPONENT_WRAPPER = 'counter-wrapper';

/**
 * Test id for wrapper div of the counter inside the slider
 */
export var RENDER_COUNTER_TESTID = 'counter-container';

/**
 * Counter label value wrapper div
 */
export var RENDER_LABEL_TESTID = 'counter_label_wrapper';
/**
 * Display reaction count next to the emoji button
 */
export var Counter = function Counter(_ref) {
  var _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    limit = _ref.limit,
    overLimitLabel = _ref.overLimitLabel,
    className = _ref.className,
    value = _ref.value,
    _ref$animationDuratio = _ref.animationDuration,
    animationDuration = _ref$animationDuratio === void 0 ? mediumDurationMs : _ref$animationDuratio;
  var getLabel = function getLabel(value) {
    // Check if reached limit
    if (limit && overLimitLabel && value >= limit) {
      return overLimitLabel || '';
    } else if (value === 0) {
      return '';
    } else {
      return formatLargeNumber(value);
    }
  };
  var lastValue = useRef();
  var label = getLabel(value);
  useEffect(function () {
    lastValue.current = value;
  }, [value]);
  var isIncreasing = useMemo(function () {
    return lastValue.current ? lastValue.current < value : false;
  }, [value]);
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: className,
    "data-testid": RENDER_COMPONENT_WRAPPER
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: countStyle
  }, jsx(ExitingPersistence, null, jsx(SlideIn, {
    enterFrom: isIncreasing ? 'top' : 'bottom',
    exitTo: isIncreasing ? 'top' : 'bottom',
    key: value,
    duration: animationDuration
  }, function (motion, direction) {
    return jsx("div", {
      ref: motion.ref,
      css: [
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      containerStyle,
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: direction === 'exiting' ? 'absolute' : undefined
      })]
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      ,
      className: motion.className,
      "data-testid": RENDER_COUNTER_TESTID
    }, jsx("span", {
      "data-testid": RENDER_LABEL_TESTID
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      ,
      css: highlight ? [counterLabelStyle, highlightStyle] : counterLabelStyle,
      key: value
    }, label));
  })));
};